import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import { Card } from "@/components/ui/card";
import { TabsList, Tabs, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@/components/ui/separator";
import CreateYourOwnGeneralTabs from "@/components/menu-management/create-your-own-general/create-your-own-general-list/create-your-own-general-tabs";
import DraftListTabs from "@/components/menu-management/create-your-own-general/create-your-own-general-list/draft-list-tabs";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import TableSkeleton from "@/components/skeleton/table-skeletion";
import useAuth from "@/hooks/useAuth";
import {
  fetchAllCreateYourOwnGenerals,
  clearCreateYourOwnGeneralMessages,
} from "@/redux/slice/menu-manage-slice/create-your-own-general-slice";
import { fetchAllDays } from "@/redux/slice/utility/day-slice";
import { clearItemVariants } from "@/redux/slice/essential-menu-slice/variants-slice";

function CreateYourOwnGeneral() {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const { getLoading } = useSelector(
    (state) => state.menuManage.createYourOwnGeneral
  );

  useEffect(() => {
    if (user?.restaurant_id) {
      dispatch(fetchAllCreateYourOwnGenerals(user.restaurant_id));
      dispatch(clearCreateYourOwnGeneralMessages());
      dispatch(clearItemVariants());
      dispatch(fetchAllDays());
    }
  }, [dispatch, user?.restaurant_id]);

  if (getLoading) return <TableSkeleton links={backofficeLinks} />;

  return (
    <Layout2
      pageName={{ title: "Choose Your Own" }}
      paths={[
        { name: "home", path: "/home" },
        { name: "Back Office", path: "/backoffice/overview" },
        { name: "Menu Management", path: "/backoffice/menu/drinks" },
        {
          name: "Choose Your Own",
          path: "/backoffice/menu/create-your-own-general",
        },
      ]}
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
    >
      <div className="container flex flex-col gap-4 mt-5">
        <Card className="bg-transparent border-0 shadow-none">
          <Tabs
            valueKey="menu-create-your-own-general"
            className="bg-transparent w-full relative"
            defaultValue="general"
          >
            <Separator className="absolute top-8" />
            <TabsList className="w-[300px]">
              <TabsTrigger className="bg-transparent" value="general">
                Choose Your Own
              </TabsTrigger>
              <TabsTrigger value="draft">Draft List</TabsTrigger>
            </TabsList>
            <CreateYourOwnGeneralTabs />
            <DraftListTabs />
          </Tabs>
        </Card>
      </div>
    </Layout2>
  );
}

export default CreateYourOwnGeneral;

